export default {
  AgreementLabel: 'Я принимаю все условия {link}.',
  AgreementLabelAnchor: 'Пользовательского соглашения',
  AnotherUser: 'Другой пользователь',
  ApplicationAskPermissions: 'Приложение {app} запрашивает доступ к следующей информации:',
  AuthorizeButtonText: 'Авторизовать',
  BackHome: 'Вернуться на сайт',
  Cancel: 'Отменить',
  Close: 'Закрыть',
  ConfirmationTitle: 'Подтверждение',
  ConsentTitle: 'Авторизовать приложение',
  DeclineAuthorizationButtonText: 'Отказать в доступе',
  EmailHint: 'Сюда будет отправлен код для завершения регистрации.',
  EmailLabel: 'Email',
  Error404Title: 'Страница не найдена',
  FatalErrorDefaultMessage: 'Ошибка',
  FillCode: 'Введите код',
  FillLogin: 'Укажите логин',
  FillNewPassword: 'Укажите новый пароль',
  FillSecret: 'Введите секретный код и укажите новый пароль:',
  ForgotTitle: 'Восстановление пароля',
  ForgotMobileTitle: 'Восстановить пароль',
  ForgotQuestion: 'Забыли?',
  Go: 'Перейти',
  here: 'здесь',
  HomePage: 'Главная страница',
  LoggedOut: 'Сеанс завершен',
  LoginAgain: 'Войти еще раз',
  LoginAnotherUser: 'Или войдите под другим пользователем:',
  LoginAs: 'Войти как',
  LoginButtonText: 'Войти',
  LoginLabel: 'Логин, телефон или email',
  LoginShortLabel: 'Логин',
  LoginHint: 'Используется для входа на сайт.',
  LoginTitle: 'Войти',
  LogoutConfirmationButtonText: 'Выйти',
  LogoutConfirmationHint: 'Вы собираетесь завершить сессию на IPRIM.RU.',
  LogoutConfirmationTitle: 'Выйти',
  MinLength: 'Минимум {min} символов',
  NewPassword: 'Новый пароль',
  NetworkError: 'Ошибка соединения с сервером.',
  Next: 'Дальше',
  NoContactsError: 'К сожалению, вы не оставили контактных данных, куда мы могли бы отправить код восстановления. Вы все еще можете восстановить доступ, обратившись к администрации сайта.',
  offlineScopeTitle: 'Офлайн доступ',
  offlineScopeDescription: 'Приложение сможет делать запросы от вашего имени, когда вы офлайн.',
  openidScopeTitle: 'Только публичная информация',
  openidScopeDescription: 'Приложение сможет идентифицировать вас и получит ограниченный доступ к публичной информации.',
  OrFillUser: 'Или самостоятельно укажите пользователя:',
  PasswordLabel: 'Пароль',
  PasswordTestLabel: 'Повторите пароль',
  PasswordsNotEqualError: 'Пароли не совпадают',
  PolicyRequiredError: 'Вы должны согласиться с политикой конфиденциальности',
  PrivacyLabel: 'Я ознакомился с {link} и подтверждаю своё согласие на обработку персональных данных.',
  PrivacyLabelAnchor: 'Политикой конфиденциальности',
  RememberMe: 'Запомнить меня',
  ResendCode: 'Чтобы отправить код повторно, нажмите',
  RequiredError: 'Поле обязательно для заполнения.',
  SavePassword: 'Сохранить пароль',
  SecretCode: 'Секретный код',
  SelectOneUser: 'По запросу "{login}" мы нашли нескольких пользователей. Выберите, к какому из них вы хотите восстановить доступ.',
  SelectPasswordFor: 'Восстановить пароль для:',
  SelectUser: 'Выберите пользователя?',
  SelectWay: 'Выберите способ',
  SelectRecoverWay: 'Выберите способ восстановления:',
  SentEmail: 'Вам отправлено письмо с секретным кодом для смены пароля.',
  SentError: 'При отправке сообщения произошла ошибка.',
  SentSms: 'Вам отправлено СМС с секретным кодом для смены пароля.',
  SignedIn: 'Вы авторизованы!',
  SignedUp: 'Вы зарегистрированы!',
  RegisterLinkText: 'Зарегистрироваться',
  RegisterTitle: 'Регистрация на',
  RegisterPageTitle: 'Регистрация',
  SmsCode: 'Код из СМС',
  TelHint: 'Для уведомлений и восстановления пароля по SMS.',
  TelLabel: 'Телефон',
  TimeoutError: 'Вы недавно запрашивали код для восстановления пароля. Если вы его не получили, в следующий раз сможете запросить через {countdown}.',
  TimeoutHint: 'Если вы не получили код, в следующий раз сможете запросить через {countdown}.',
  TooEasyPasswordError: 'Пароль слишком простой.',
  TosRequiredError: 'Вы должны согласиться с пользовательским соглашением',
  UserNotFound: 'Пользователь не найден.',
  WillRedirect: 'Сейчас вы будете перенаправлены на сайт.',
  WillRedirectAfterLogout: 'Сеанс завершен. Через несколько секунд вы вернетесь на сайт.',

  // fatal errors
  'invalid_request': 'Ошибка в запросе',

  // validation errors
  'email must be an email': 'Некорректный e-mail',
  'tel must be a phone number': 'Некорректный номер телефона'
}
